"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationResult_1 = require("./ValidationResult");
var formatFunctions_1 = require("../formatFunctions");
function validateTable(schema, data, path, exitOnFirstError) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var result = [];
    if (schema.minLength !== undefined) {
        if (data.length < schema.minLength) {
            var err = {
                validation: 'minLength',
                expected: schema.minLength,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    if (schema.maxLength !== undefined) {
        if (data.length > schema.maxLength) {
            var err = {
                validation: 'maxLength',
                expected: schema.maxLength,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateTable = validateTable;
function validateField(schema, data, path, exitOnFirstError) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var schemaIsNumber = false;
    var dataIsNumber = false;
    var result = [];
    // console.log(JSON.stringify(schema));
    if (schema.type === 'number' || schema.type === 'money') {
        schemaIsNumber = true;
        if (typeof data !== 'number') {
            // result.valid = false;
            var err = {
                validation: 'type',
                expected: schema.type,
                value: typeof data,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
        else {
            dataIsNumber = true;
        }
    }
    else if (schema.type === 'int' || schema.type === 'integer') {
        schemaIsNumber = true;
        if (typeof data !== 'number') {
            // result.valid = false;
            var err = {
                validation: 'type',
                expected: schema.type,
                value: typeof data,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
        else {
            if (data % 1 !== 0) {
                // result.valid = false;
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: 'float',
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                dataIsNumber = true;
            }
        }
    }
    if (schemaIsNumber) {
        if (dataIsNumber) {
            if (schema.maximum !== undefined) {
                if (data > schema.maximum) {
                    var err = {
                        validation: 'maximum',
                        expected: schema.maximum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.exclusiveMaximum !== undefined) {
                if (data >= schema.exclusiveMaximum) {
                    var err = {
                        validation: 'exclusiveMaximum',
                        expected: schema.maximum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.minimum !== undefined) {
                if (data < schema.minimum) {
                    var err = {
                        validation: 'minimum',
                        expected: schema.minimum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            if (schema.exclusiveMinimum !== undefined) {
                if (data <= schema.exclusiveMinimum) {
                    var err = {
                        validation: 'exclusiveMinimum',
                        expected: schema.minimum,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
            // multipleOf
            if (schema.multipleOf !== undefined) {
                if (data % schema.multipleOf !== 0) {
                    var err = {
                        validation: 'multipleOf',
                        expected: schema.multipleOf,
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
        }
    }
    else {
        if (schema.type === 'string') {
            if (typeof data !== 'string') {
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: typeof data,
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                if (schema.maxLength !== undefined) {
                    var l = data.length;
                    if (l > schema.maxLength) {
                        var err = {
                            validation: 'maxLength',
                            expected: schema.maxLength,
                            value: l,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
                if (schema.minLength !== undefined) {
                    var l = data.length;
                    if (l < schema.minLength) {
                        var err = {
                            validation: 'minLength',
                            expected: schema.minLength,
                            value: l,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
                // pattern
                if (schema.format !== undefined && data) {
                    var ok = formatFunctions_1.checkFormat(schema.format, data);
                    if (!ok) {
                        var err = {
                            validation: 'format',
                            expected: schema.format,
                            value: data,
                            path: path
                        };
                        if (exitOnFirstError) {
                            return err;
                        }
                        result.push(err);
                    }
                }
            }
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateField = validateField;
function _validate(schema, data, path, exitOnFirstError, result) {
    if (schema.type === 'object') {
        var required = schema.required || [];
        if (schema.properties) {
            for (var key in schema.properties) {
                // for (let key of schema.$keys) {
                if (schema.properties.hasOwnProperty(key)) {
                    var element = schema.properties[key];
                    var value = data[key];
                    if (required.indexOf(key) > -1) {
                        if (value === undefined
                            || (element.type === 'string' && !value)
                            || (element.type === 'integer' && !value)) {
                            // result.valid = false;
                            result.errors.push({
                                validation: 'required',
                                path: path === '' ? key : path + '.' + key
                            });
                            if (exitOnFirstError) {
                                continue;
                            }
                        }
                    }
                    if (value !== undefined) {
                        _validate(element, value, path === '' ? key : path + '.' + key, exitOnFirstError, result);
                    }
                }
            }
        }
    }
    else if (schema.type === 'array') {
        if (exitOnFirstError) {
            var err = validateTable(schema, data, path, true);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            var errs = validateTable(schema, data, path, false);
            if (errs.length) {
                result.errors = result.errors.concat(errs);
            }
        }
        // uniqueItems
        // contains
        var items = schema.items;
        if (items) {
            for (var i = 0; i < data.length; i++) {
                var res = _validate(items, data[i], path + '[' + i + ']', exitOnFirstError, result);
            }
        }
    }
    else {
        if (exitOnFirstError) {
            var err = validateField(schema, data, path, true);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            var errs = validateField(schema, data, path, false);
            if (errs.length > 0) {
                result.errors = result.errors.concat(errs);
            }
        }
    }
}
/**
 * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
 * @param data dane do sprawdzenia
 * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
 * @param path sciezka startowa pola, przy pominięciu ustawia pustą
 */
function validate(schema, data, exitOnFirstError, path) {
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    if (path === void 0) { path = ''; }
    var result = new ValidationResult_1.default();
    _validate(schema, data, path || '', exitOnFirstError, result);
    if (result.errors.length) {
        result.valid = false;
    }
    return result;
}
exports.default = validate;
//# sourceMappingURL=validate.js.map